// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"cbcff3e8","242":"6e57f262","985":"bedf7c75"}[chunkId] + ".chunk.css";
};